<template>
  <div>
    <div class="metadata-dock-header" style="height: 36px">
      <span>{{$t('Metadata')}}</span>
      <!-- <svg
        width="2em"
        height="1.5em"
        v-on:click="closeMetadataDock"
        viewBox="0 0 16 16"
        class="bi bi-arrow-right-circle"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
        />
        <path
          fill-rule="evenodd"
          d="M4 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5A.5.5 0 0 0 4 8z"
        />
      </svg> -->
    </div>
    <div style="height: 92%; display:flex; width: 100%">
      <tag-metadata ref="tagMetadataPanel" :assetDetailsFromParent="assetDetails" :fileInfo="selectedFileInfo" screenType="Tag Metadata"
       :isMetadataDock="true" @openSubclipWindow="openSubclipWindow" :isVideoFile="checkIfVideoFile" @navigateToAIComponent="handleAIComponentNavigation" @updateAssetDeatils="updateAssetDeatils"></tag-metadata>
    </div>
  </div>
</template>

<script>
// import Utils from "../../components.utils.js"
// import Constants from "../../components.constants.js"
import "vue2-datepicker/index.css";
import tagMetadataComponent from "../files/TagMetadataComponent.vue" 

export default {
/*     setup(){                                     //Initialise toast and access it using this.toast
        const toast = Utils.setupToast()
        return {toast}
    }, */
    data(){
        return{
            editingCustomMetadata : {},
            freetextVal:"",
            customMapper:{},
            integerVal:"",
            initialValues:[],
            assetDetails:{},
            selectedFileInfo:{},
            globalSearchedValue:'',
        }
    },
    props:["basicAssetInfo","fileInfo","searchedText"],
    components:{
      "tag-metadata":tagMetadataComponent
    },
    methods:{
      handleAIComponentNavigation(componentType){
        this.$emit("AIComponentNavigation",componentType)
      },
      openSubclipWindow(selectedSubclip,subComponentName,compType){
        let paramObj = {assetId: this.assetDetails._id, fileInfo:Object.assign({}, this.assetDetails),parentinfo:this.$route}
          if(selectedSubclip){
            paramObj["subclipId"] = selectedSubclip.asset_id;
            paramObj["subclipInfo"] = selectedSubclip;
          }
        let route_name = "metadata-dock-bin-sub-clips-manager";
        if(this.$route.name == 'catalogs-display' && compType == 'subclips'){
          route_name = "metadata-dock-sub-clips-manager";
        }
        if(compType == 'media-edit'){
          if(this.$route.name == 'catalogs-display'){
            route_name = "PartialRetrieve-from-metadata-dock";
          }else{
            route_name = "PartialRetrieve";
          }
        }
        if(compType == "transcript"){
          if(this.$route.name == 'catalogs-display'){
            route_name = "metadata-dock-video-transcript-manager"
          }else{
            route_name = "bins-metadata-dock-video-transcript-manager"
          }
        }
        this.$router.push({
            name:route_name,
            params:paramObj
          })
      },
      closeMetadataDock(){
          this.$emit("hideMetadataDock");
      },
      unselectActiveSubclipPreview(){
          if(this.$refs && this.$refs.tagMetadataPanel){
              this.$refs.tagMetadataPanel.activeSubclipPreview = '';
          }
      },
      updateAssetDeatils(assetDetailsVal){
        if(assetDetailsVal && Object.keys(assetDetailsVal).length>0){
          Object.assign(this.assetDetails, assetDetailsVal);
        }
      },
    },
    computed:{
      checkIfVideoFile(){
        if(this.assetDetails && this.assetDetails.mime_type){
          if(this.assetDetails.mime_type.split("/")[0] == 'video'){
            return true
          }
        }
          return false
        }
    },
    watch:{
      basicAssetInfo(newVal,oldVal){
        if(oldVal != newVal){
          this.assetDetails = newVal;
          this.$refs.tagMetadataPanel.resetEditMode();
        }
      },
      fileInfo(newVal,oldVal){
        if(oldVal != newVal){
          this.selectedFileInfo  = newVal;
        }
      },
      searchedText(newVal,oldVal){
          if(oldVal != newVal){
              this.globalSearchedValue = newVal;
          }
      }
    },
    created(){
     this.assetDetails = this.basicAssetInfo;
     if(!('file_id' in this.assetDetails)){
        this.assetDetails['file_id'] = (this.fileInfo.file_id || null);
     }
     this.selectedFileInfo = this.fileInfo;
     if(this.searchedText)
        this.globalSearchedValue = this.searchedText;
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #1e1e1e;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$danger-color: #dc3545 !important;
$active-blue: #007bff;
$header-color:#9e9e9e;
$tag-metadata-bg-color:#15181B;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 22%;
}
/* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

.metadata-dock-header {
  border-bottom: $border-color;
  background: $tag-metadata-bg-color;
  span {
    float: inline-start;
    padding: 4px;
    font-size: 18px;
    padding-inline-start: 10px;
  }
  svg {
    float: inline-end;
    margin: 7px;
    color: $text-color !important;
  }
}

</style>
